import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgMultipleQuestionsOutlined = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M68 86c-.5 0-1-.2-1.4-.6l-8-8c-.8-.8-.8-2 0-2.8s2-.8 2.8 0l6.6 6.6 14.6-14.6c.8-.8 2-.8 2.8 0s.8 2 0 2.8l-16 16c-.4.4-.9.6-1.4.6M52 54H28c-1.1 0-2-.9-2-2s.9-2 2-2h24c1.1 0 2 .9 2 2s-.9 2-2 2m0-16H28c-1.1 0-2-.9-2-2s.9-2 2-2h24c1.1 0 2 .9 2 2s-.9 2-2 2" />
    <path d="M44 86H16c-3.3 0-6-2.7-6-6V16c0-3.3 2.7-6 6-6h44c.5 0 1 .2 1.4.6l8 8c.4.4.6.9.6 1.4v40c0 1.1-.9 2-2 2s-2-.9-2-2V20.8L59.2 14H16c-1.1 0-2 .9-2 2v64c0 1.1.9 2 2 2h28c1.1 0 2 .9 2 2s-.9 2-2 2" />
    <path d="M68 22h-8c-1.1 0-2-.9-2-2v-8c0-.8.5-1.5 1.2-1.8s1.6-.1 2.2.4l8 8c.6.6.7 1.4.4 2.2-.3.7-1 1.2-1.8 1.2m-6-4h1.2L62 16.8z" />
  </svg>
);
export default SvgMultipleQuestionsOutlined;
